<template><span class="none"></span></template>
<style>
@import '~@npm/@gd/game-technologies-check/dist/game-technologies-check.css';
</style>
